import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-implant-refund-bill-item.reducer';

export const PharmacyImplantRefundBillItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyImplantRefundBillItemEntity = useAppSelector(state => state.pharmacyImplantRefundBillItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyImplantRefundBillItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.detail.title">PharmacyImplantRefundBillItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.id}</dd>
          <dt>
            <span id="chargedMrp">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.chargedMrp">Charged Mrp</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.chargedMrp}</dd>
          <dt>
            <span id="refundPaid">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.refundPaid">Refund Paid</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.refundPaid}</dd>
          <dt>
            <span id="refundQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.refundQty">Refund Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.refundQty}</dd>
          <dt>
            <span id="soldQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.soldQty">Sold Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.soldQty}</dd>
          <dt>
            <span id="manufacDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.manufacDate">Manufac Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.manufacDate}</dd>
          <dt>
            <span id="expDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.expDate">Exp Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.expDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.cursor}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.lastupdated}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.pharmacyStock">Pharmacy Stock</Translate>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.pharmacyStock ? pharmacyImplantRefundBillItemEntity.pharmacyStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.saleBillItem">Sale Bill Item</Translate>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.saleBillItem ? pharmacyImplantRefundBillItemEntity.saleBillItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.refundBill">Refund Bill</Translate>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.refundBill ? pharmacyImplantRefundBillItemEntity.refundBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.saleBill">Sale Bill</Translate>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.saleBill ? pharmacyImplantRefundBillItemEntity.saleBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.returnBill">Return Bill</Translate>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.returnBill ? pharmacyImplantRefundBillItemEntity.returnBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantRefundBillItem.returnItem">Return Item</Translate>
          </dt>
          <dd>{pharmacyImplantRefundBillItemEntity.returnItem ? pharmacyImplantRefundBillItemEntity.returnItem.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-implant-refund-bill-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-implant-refund-bill-item/${pharmacyImplantRefundBillItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyImplantRefundBillItemDetail;
